import { useSelector } from "react-redux"
import Squares from "../../../components/04_common/03_squares/Squares"
import dialoguesImage from "./01_images/dialogues.jpg"
import storiesImage from "./01_images/stories.jpg"
import { speaking } from "../../../i18n/09_speaking"

const ReadingSquares = () => {

  const lang = useSelector(state => state.lang.lang)
  const t = speaking[lang]
  const images = [dialoguesImage, storiesImage]

  const items = t.squares.map((value, index) => ({
    src: images[index],
    title: value.title,
    path: value.path
  }))


  return (
    <Squares items={items} />
  )
}

export default ReadingSquares